import service from '@/api/roleGroup';
import {loading, handleError} from '@/state/generators/helpers';
import {alert} from "../generators/helpers";

export const state = {
    loading: false,
    service: service('roleGroups'),
    loadingPermissions: false,
    permissionTree: [],
}

export const getters = {
    permissionLoading: (state) => {
        return !!state.loadingPermissions;
    },

    permissionTree: (state) => {
        return JSON.parse(JSON.stringify(state.permissionTree))
    },
}

export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean
    },

    'SET_LOADING_PERMISSIONS': function (state, boolean = true) {
        state.loading = boolean;
    },

    'SET_PERMISSION_TREE': function (state, data = []) {
        state.permissionTree = data;
    },
}

export const actions = {
    roles: function ({commit, state}, payload) {
        loading(commit)

        const id = payload.id
        delete payload.id

        return state.service.syncRoles(id, payload).then(response => {
            loading(commit, false)
            alert(commit, this.$t('request.save_is_successful'))
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    fetchPermissionTree: ({ commit }, id) => {
        commit('app/SET_LOADING', true, {root: true})
        commit('SET_LOADING_PERMISSIONS', true)

        return state.service.fetchRoles(id).then(response => {
            commit('SET_PERMISSION_TREE', response.data);
            commit('app/SET_LOADING', false, {root: true})
            commit('SET_LOADING_PERMISSIONS', false)
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        });
    },

    saveRoles: function ({commit}, {id, roles}) {
        commit('app/SET_LOADING', true, {root: true})
        commit('SET_LOADING_PERMISSIONS', true)

        return state.service.saveRoles(id, roles).then(response => {
            commit('SET_PERMISSION_TREE', response.data)
            commit('app/SET_LOADING', false, {root: true})
            alert(commit, this.$t('request.save_is_successful'))
            commit('SET_LOADING_PERMISSIONS', false)
            return response.data;
        }).catch((e) => {
            handleError(e, commit)
        })
    },
}
